import Content from '../layout/content.vue';

export default Content;



// WEBPACK FOOTER //
// ./src/components/content/index.js